module.exports = __webpack_public_path__ + "static/img/hero-card-bg.e5da9950.png";